import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import ReactTooltip from 'react-tooltip';

import styled from '@emotion/styled';

const ErrorContainerWrapper = styled.div`
  margin-left: 6px;
  display: flex;
  align-items: center;

  a {
    color: red;
    display: flex;
    align-items: center;
  }

  .error-background {
    width: 30px;
    height: 30px;
    display: flex;
    background-color: #ffbfbf;
    justify-content: center;
    align-items: center;
    border: solid 1px red;
    border-radius: 4px;

    div {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid red;
      border-radius: 100%;
    }
  }

  .error-arrow {
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 8px 7px 8px 0px;
    border-color: transparent red transparent transparent;
    display: flex;
    align-items: center;

    div {
      border-color: transparent #ffbfbf transparent transparent;
      border-width: 7px 7px 7px 0px;
      margin-left: 1px;
      z-index: 0;
    }
  }
`;

class ErrorContainer extends React.Component {
  render() {
    if (!this.props.error) return null;

    return (
      <ErrorContainerWrapper className="error-container">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a data-for="error-tip" data-tip={this.props.error}>
          <div className="error-arrow">
            <div className="error-arrow"></div>
          </div>
          <div className="error-background">
            <div>
              <FontAwesome name="exclamation" />
            </div>
          </div>
        </a>
        <ReactTooltip id="error-tip" />
      </ErrorContainerWrapper>
    );
  }
}

ErrorContainer.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

ErrorContainer.defaultProps = {
  error: null,
};

export default ErrorContainer;
